<main
    class="layout slide-y-animation xl:hidden overflow-x-hidden absolute z-[999] inset-0 w-full h-screen bg-white"
>
    <section class="flex fixed top-0 z-10 flex-col w-full safe-top bg-primary">
        <section class="flex justify-between p-4 w-full">
            <app-icon
                (click)="goBack($event)"
                name="material-symbols:arrow-back-ios"
                class="text-white cursor-pointer"
                size="sm"
            />

            <ng-content select="[icons]" />
        </section>
        <section class="p-4 flex items-center justify-between min-h-[6.25rem]">
            <p class="text-2xl font-semibold text-white">마이 페이지</p>
            <img src="logo5.svg" class="size-16" alt="마이페이지 이미지" />
        </section>
        <section class="bg-white">
            <app-segment
                scrollEnabled
                [(value)]="segment"
                (valueChange)="onSegmentChange($event)"
                [options]="segmentOptions()"
            />
        </section>
    </section>
    <section
        class="layout z-[999] bg-white h-full pb-20 pt-[12rem] overflow-y-auto"
    >
        <ng-content />
    </section>
    <section class="fixed bottom-0 w-full bg-white">
        <ng-content select="[footer]" />
    </section>
</main>
